import { useState, useEffect } from "react";

const UPDATE_FREQ_SECS = 5;

const getDeltaString = (delta: number) => {

    const seconds = delta / 1000;

    if (seconds < 10) {
        return "Moments ago";
    }
    if (seconds < 60) {
        return "Less than a minute ago";
    }

    const minutes = seconds / 60;

    return `${Math.floor(minutes)} minutes ago`;

}

interface iTimestampProps {
    timestring: string;
}

const Timestamp = ({timestring}: iTimestampProps) => {
    const [delta, setDelta] = useState<number>(0);

    useEffect(()=> {
        const updated = new Date(timestring).getUTCSeconds();
        const interval = setInterval(()=>{
            const now = new Date().getUTCSeconds();
            setDelta(now - updated);
        }, UPDATE_FREQ_SECS * 1000)

        return ()=>clearInterval(interval);
    }, [timestring])

    const updated = new Date(timestring);
    const minutes = updated.getMinutes();

    const minuteString = minutes < 10 ? `0${minutes}` : `${minutes}`;

    return <span>{updated.getHours()}:{minuteString} ({getDeltaString(delta)})</span>
}


export default Timestamp;